/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';
import { NodeProps, Position, Handle } from 'reactflow';
import { useSelector, useDispatch } from 'react-redux';
import ContentDiv from 'src/components/ui/ContentDiv/ContentDiv';
import TextAreaMenu from 'src/components/layouts/TextAreaMenu/TextAreaMenu';
import classNames from 'classnames';
import NodeHeader from 'src/components/ui/NodeHeader/NodeHeader';
import { getWorkflows } from 'src/redux/workflows/selectors';
import { setNodeConfiguration } from 'src/redux/workflows/slice';
import { useWorkflowsActionsPlaceholdersQuery } from 'src/services/workflows';
import { useTranslation } from 'react-i18next';
import Input from 'src/components/ui/Input/Input';
import styles from './EmailBuilderNode.module.scss';

const EmailBuilderNode: React.FC<NodeProps> = ({ id, data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState('');
  const [titleValue, setTitleValue] = useState<string>('');
  const [contentValue, setContentValue] = useState<string>('');

  const workflowState = useSelector(getWorkflows);
  const { selectedTrigger } = workflowState;

  const hasValidModel = !!(selectedTrigger?.model && selectedTrigger.model.trim() !== '');

  // Initialize state with existing data
  useEffect(() => {
    if (data.actionData) {
      const { title, message } = data.actionData;

      if (title && title !== titleValue) {
        setTitleValue(title);
      }

      if (message && message !== contentValue) {
        setContentValue(message);
      }
    }
  }, [data.actionData]);

  useEffect(() => {
    console.log('titleValue', titleValue);
  }, [titleValue]);

  const handleResetClick = () => {
    if (data.isEditMode && data.removeNode) {
      data.removeNode(id);
    } else if (data.isEditMode) {
      setSelectedOption('');
      if (data.removeLastNode) {
        data.removeLastNode();
        data.removeLastNode();
      }
    }
  };

  const { data: variablesData } = useWorkflowsActionsPlaceholdersQuery(selectedTrigger?.model || '', hasValidModel);

  const variables =
    variablesData?.map(item => ({ variableName: `{${item.name}}`, variableLabel: `{${item.label}}` })) || [];

  const actionTitle = t('workflows.send_email');
  const actionIcon = data.actionData?.icon || 'send';

  const updateNodeConfiguration = () => {
    dispatch(
      setNodeConfiguration({
        nodeId: id,
        nodeType: 'action',
        data: {
          actionType: 'mail',
          title: titleValue,
          returnValue: contentValue,
          content: contentValue,
        },
      }),
    );
  };

  const handleTitleChange = (value: string) => {
    if (!data.isEditMode) return;
    setTitleValue(value);
    updateNodeConfiguration();
  };

  const handleContentChange = (value: string) => {
    if (!data.isEditMode) return;
    setContentValue(value);
    updateNodeConfiguration();
  };

  return (
    <div className={classNames(styles.root)}>
      <div className={styles.content}>
        <div className="py-16 px-20">
          <NodeHeader
            title={actionTitle}
            subtitle="Aktion"
            icon={actionIcon}
            onActionClick={handleResetClick}
            isEditMode={data.isEditMode}
          />
        </div>
        <div className="px-20">
          {/* <ContentDiv
            label="Betreff"
            value={titleValue}
            onChange={e => handleTitleChange(e.target.innerHTML)}
            className={styles.title}
            hasVariableInsertion={data.isEditMode}
            variables={variables}
            disabled={!data.isEditMode}
          /> */}
          <Input
            value={titleValue}
            label={t('workflows.subject')}
            onChange={e => handleTitleChange(e.target.value)}
            placeholder={t('workflows.notification_title_placeholder')}
            className="w-full"
            disabled={!data.isEditMode}
          />
        </div>
        <div className="px-20 my-20">
          <TextAreaMenu
            label="Inhalt"
            value={contentValue}
            onChange={e => handleContentChange(e.target.innerHTML)}
            className={styles.contentArea}
            variables={variables}
            disabled={!data.isEditMode}
          />
        </div>
        <Handle
          type="source"
          position={Position.Right}
          id={`${id}`}
          style={{
            opacity: 0,
            top: '37px',
            position: 'absolute',
            right: '0%',
            width: '1px !important',
            height: '1px !important',
          }}
        />
        <Handle
          type="source"
          position={Position.Left}
          id={`${id}`}
          style={{
            opacity: 0,
            top: '37px',
            position: 'absolute',
            left: '0%',
            width: '1px !important',
            height: '1px !important',
          }}
        />
        <Handle type="source" position={Position.Top} id={`${id}`} style={{ opacity: 0, top: '37px' }} />
        <Handle type="source" position={Position.Bottom} id={`${id}`} style={{ opacity: 0, top: '37px' }} />
        <Handle
          type="target"
          position={Position.Left}
          id={`${id}`}
          style={{
            opacity: 0,
            top: '37px',
            position: 'absolute',
            left: '0%',
            width: '1px !important',
            height: '1px !important',
          }}
        />
      </div>
    </div>
  );
};

export default EmailBuilderNode;
